import React from 'react';
import { TagData } from '../../../../types/types';
import useTagSelected from '../../../../hooks/useTagSelected';
import { Card, CardContent } from '../../../ui/card';

/**
 * Props for the Tag component.
 *
 * t - The tag object.
 * clickTag - Function to handle the tag click event.
 */
interface TagProps {
  t: TagData;
  clickTag: (tagName: string) => void;
}

/**
 * Tag component that displays information about a specific tag.
 * The component displays the tag's name, description, and the number of associated questions.
 * It also triggers a click event to handle tag selection.
 *
 * @param t - The tag object .
 * @param clickTag - Function to handle tag clicks.
 */
const TagView = ({ t, clickTag }: TagProps) => {
  const { tag } = useTagSelected(t);

  return (
    <Card
      className='cursor-pointer hover:shadow-md transition-shadow border border-dashed border-gray-300'
      onClick={() => clickTag(t.name)}>
      <CardContent className='p-4 flex flex-col items-center text-center'>
        <div className='text-blue-500 font-medium mb-2'>{tag.name}</div>
        <div className='text-sm text-gray-600 mb-3'>{tag.description}</div>
        <div className='text-xs text-gray-500'>{t.qcnt} questions</div>
      </CardContent>
    </Card>
  );
};

export default TagView;
